import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useMenuToggleButtonStyles = makeStyles(() =>
  createStyles({
    menuToggle: {
      transition: 'transform .25s ease-out',
    },
    menuToggleClosed: {
      transform: 'rotate(180deg)',
    },
  })
);

export default useMenuToggleButtonStyles;
